/**
 * Copyright 2025 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */

import {PropTypes} from 'preact-compat';
import FullScreenMessage from '../../shared/components/FullScreenMessage';
import {BitRateSelect} from './PublisherControls';
import styles from '../../../css/publisher.css';

const MediaUriPublisher = ({
  publishToChannel,
  stopPublisher,
  errorMessage,
  changeUriQuality,
  changeStreamUri,
  uriQuality,
  streamUri,
  publishWithUriResponse
}) => {
  return (
    <div className={styles.container}>
      <div className={styles.rightColumn}>
        <h2>Media Uri to Publish</h2>

        <BitRateSelect
          onChange={changeUriQuality}
          defaultValue={uriQuality}
        />

        <input
          className={`${styles.streamUriInput} ${publishWithUriResponse ? styles.disabled : ''}`}
          type="text"
          value={streamUri}
          onChange={(event) => changeStreamUri(event.target.value)}
          placeholder="https://LinkToMyMedia.mp4 OR rtmp://LinkToMyMedia.flv OR ..."
        />

        {!publishWithUriResponse ? (
          <div className={styles.publisherControls}>
            <button
              className={styles.confirmButton}
              onClick={() => publishToChannel(streamUri)}/>
          </div>
        ) : (
          <div className={styles.publisherResult}>
            <div className={styles.publisherControls}>
              <button
                className={styles.cancelPublisherButton}
                onClick={stopPublisher}/>
            </div>
            <div id="data-stream-id" data-stream-id={publishWithUriResponse.streamId} />
            <FullScreenMessage messages={['No preview available. Open a channel viewer if you would like to see the stream.']}/>
          </div>
        )}

        {errorMessage && (
          <FullScreenMessage messages={[`Error: ${errorMessage}`]}/>
        )}
      </div>
    </div>
  );
};

MediaUriPublisher.propTypes = {
  publishToChannel: PropTypes.func.isRequired,
  stopPublisher: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  changeUriQuality: PropTypes.func.isRequired,
  changeStreamUri: PropTypes.func.isRequired,
  uriQuality: PropTypes.string,
  streamUri: PropTypes.string,
  publishWithUriResponse: PropTypes.object
};

export default MediaUriPublisher;